module.exports = __webpack_public_path__ + "static/CalibreWeb-Bold-1beaf4058862e53f859d361774c84821.woff2";